import { View } from 'backbone';
import eventBus         from 'EventBus.js';
import BaseControlView from 'BaseControlView.js';
import constants        from "Constants.js";
import template from 'report/control-crosstab.ejs';

class CrosstabView extends BaseControlView  {

    initialize( opts ) {

        super.initialize( opts );

        this.template = template;
        this.tagName = 'div';
        this.family = constants.CONTROL_COMMON_INPUTS;
        this.icon = 'pf-dropdown';

        this.listenTo(this.model, 'change', this.render);
        this.listenTo( eventBus, 'InputThemeChange', this.themeChangeRender);

        return this;
    }



    get kind() {
        return 'BaseStaticControl';
    }

    render(){
        this.model.set('normalRowBgColor', this.resolveThemeProp(this.model.get('normalRowBgColor')), {silent: true})
        this.model.set('alternateRowBgColor', this.resolveThemeProp(this.model.get('alternateRowBgColor')), {silent: true})
        super.render();
    }

}

export default CrosstabView;
